import { useMemo } from 'react';

const BAR_COLORS = ['#1d4ed8', '#2563eb', '#3b82f6', '#60a5fa'];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export default function BarChartDisplay({ slide, responses, participantCount }) {
  const options = slide?.config?.options || [];

  const { voteCounts, maxVotes, totalVotes } = useMemo(() => {
    const counts = new Array(options.length).fill(0);
    for (const r of responses) {
      const idx = Number(r.value);
      if (!isNaN(idx) && idx >= 0 && idx < options.length) {
        counts[idx]++;
      }
    }
    const max = Math.max(...counts, 1);
    const total = counts.reduce((s, c) => s + c, 0);
    return { voteCounts: counts, maxVotes: max, totalVotes: total };
  }, [responses, options.length]);

  if (responses.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 w-full">
        <div className="flex flex-col gap-4 w-full max-w-3xl">
          {options.map((opt, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="text-white font-bold text-lg w-8 shrink-0">
                {LETTERS[i]}
              </span>
              <span className="text-blue-200 text-lg">{opt}</span>
            </div>
          ))}
        </div>
        <p className="text-blue-300 text-2xl animate-pulse mt-4">Inga stemmer enno...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full gap-6">
      <div className="flex flex-col gap-5 w-full max-w-3xl">
        {options.map((opt, i) => {
          const count = voteCounts[i];
          const pct = totalVotes > 0 ? Math.round((count / totalVotes) * 100) : 0;
          const widthPct = maxVotes > 0 ? (count / maxVotes) * 100 : 0;
          const color = BAR_COLORS[i % BAR_COLORS.length];

          return (
            <div key={i} className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <span className="text-white font-bold text-lg w-8 shrink-0">
                  {LETTERS[i]}
                </span>
                <span className="text-blue-100 text-lg truncate">{opt}</span>
              </div>
              <div className="flex items-center gap-3 ml-10">
                <div className="flex-1 bg-gray-700 rounded-full h-10 overflow-hidden">
                  <div
                    className="h-full rounded-full flex items-center justify-end pr-3 transition-all duration-700 ease-out"
                    style={{
                      width: `${Math.max(widthPct, count > 0 ? 8 : 0)}%`,
                      backgroundColor: color,
                    }}
                  >
                    {count > 0 && (
                      <span className="text-white font-semibold text-sm whitespace-nowrap">
                        {count} ({pct}%)
                      </span>
                    )}
                  </div>
                </div>
                {count === 0 && (
                  <span className="text-gray-500 text-sm">0</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-blue-300 text-lg">
        {totalVotes} stemmer totalt
      </p>
    </div>
  );
}
